namespace advisorop.components.servicer {
    
    class ServicerAppController  {
        
        static $inject = ["identityService"];
        constructor(private identityService: services.IdentityService) {           
        }
        
        $onInit(): void {
        }

        $routerOnActivate(next, previous) {
        }
    }



    class ServicerApp implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public $routeConfig: any;

        constructor() {
            this.bindings = { 
            };
            this.controller = ServicerAppController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/servicer-module/components/servicer-app.html';

            this.$routeConfig = [
                { path: "/dashboard", component: "servicerDashboard", name: "Dashboard" },
                { path: "/userprofile", component: "userProfile", name: "UserProfile" },            
                { path: "/createservicer", component: "servicerCrud", name: "CreateServicer" },
                { path: "/createadvisor", component: "advisorCrud", name: "CreateAdvisor" },
                { path: "/updateadvisor/:advisorId", component: "advisorCrud", name: "UpdateAdvisor" },
                { path: "/crudadvisoryfirm", component: "advisoryFirmCrud", name: "AdvisoryFirmCrud" },
                { path: "/createcompanygroup", component: "companyGroupCrud", name: "CreateCompanyGroup" },
                { path: "/manageworkflows", component: "workflowCrud", name: "ManageWorkflows" },
                { path: "/companygroupdetails/:id", component: "companyGroupCrud", name: "CompanyGroupDetails" },
                { path: "/servicerdetails/:id", component: "servicerCrud", name: "ServicerDetails" },
                { path: "/repfeegroups/:id", component: "repFeeGroupWrapperServicer", name: "RepFeeGroupWrapperServicer" },
                { path: "/accountmaintenanceservicer", component: "accountMaintenanceServicer", name: "AccountMaintenanceServicer" }, 
                { path: "/accountmappingservicer/:ppAccountId/:companyGroupId", component: "accountMappingServicer", name: "AccountMappingServicer" },
                { path: "/manualaccountmappingservicer/:ppAccountId/:companyGroupId", component: "newManualAccountServicer", name: "ManualAccountMappingServicer" },
                { path: "/advisoryfirmdetails/:id", component: "advisoryFirmCrud", name: "AdvisoryFirmDetails" },
                { path: "/createmanager", component: "cuManager", name: "CreateManager" },                
                { path: "/editmanager/:managerId", component: "cuManager", name: "EditManager" },
                { path: "/linkmaintenance", component: "linkMaintenance", name: "LinkMaintenance" },
                { path: "/links", component: "links", name: "Links" },
                { path: "/securities", component: "securitiesList", name: "SecuritiesList" },
                { path: "/securitiesnew", component: "securitiesListNew", name: "SecuritiesListNew" },
                { path: "/operation/:show", component: "servicerOperation", name: "Operation" },
                { path: "/modeloperation/:show", component: "servicerModeloperation", name: "Modeloperation" },
                { path: "/manualaccountsexport", component: "manualAccountsExport", name: "ManualAccountsExport" }, //exporting manual accounts to PP
                { path: "/documentuploader/:type", component: "documentUploader", name: "DocumentUploader" }, //exporting manual accounts to PP
                { path: "/workflowMonitorFullscr/:workflowMasterId", component: "workflowMonitorFullscr", name: "WorkflowMonitorFullscr" },

                // originaly this component was made for advisor
                { path: "/openaccount/:accountId", component: "newAccountWiz", name: "UpdateAccount" }, 

                // alerts & notes
                { path: "/alerttask", component: "alertCuWrapper", name: "AlertCuWrapper" },
                { path: "/alertdashboard", component: "alertDashboard", name: "AlertDashboard" },
                //{ path: "/alertdashboard/usertaskentry/:showUserentry", component: "alertDashboard", name: "ServiceRequests" },
                //{ path: "/alertdashboard/workflowtasksalerts/:showWfTask", component: "alertDashboard", name: "WorkflowTasksAlerts" },
                //{ path: "/alertdashboard/riskmonitoralerts/:showRsikMonitorAlerts", component: "alertDashboard", name: "RiskMonitorAlerts" },
                { path: "/apptracker", component: "appTrackerServicer", name: "AppTrackerServicer" },
                { path: "/adobesignintegrationrequest", component: "adobesignIntegrationRequest", name: "AdobesignIntegrationRequest" },
                { path: "/adobesignintegrationresponse", component: "adobesignIntegrationResponse", name: "AdobesignIntegrationResponse" },
                { path: "/docusignintegrationrequest", component: "docusignIntegrationRequest", name: "DocusignIntegrationRequest" },
                { path: "/docusignintegrationresponse", component: "docusignIntegrationResponse", name: "DocusignIntegrationResponse" },
                { path: "/servicermsgraphintegrationrequest", component: "servicerMsgraphIntegrationRequest", name: "ServicerMsgraphIntegrationRequest" },
                { path: "/servicermsgraphintegrationresponse", component: "servicerMsgraphIntegrationResponse", name: "ServicerMsgraphIntegrationResponse" },
                { path: "/orionintegrationrequest", component: "orionIntegrationRequest", name: "OrionIntegrationRequest" },
                { path: "/orionintegrationresponse", component: "orionIntegrationResponse", name: "OrionIntegrationResponse" },

                // Hidden system-admin maintenance page (login 00000001 only; gated in the component + API)
                { path: "/adminmaintenance", component: "adminMaintenance", name: "AdminMaintenance" },

                // AI assistants connecting over MCP (servicer admin only; gated in the component + API)
                { path: "/aiconnections", component: "aiConnections", name: "AiConnections" },

                { path: "/**", redirectTo: ["Dashboard"] }
            ];
        }
    }
    angular.module(Constants.APP).component("servicerApp", new ServicerApp());
}